import React, { useState, useRef, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from "primereact/inputtext";
import { Controller, useForm } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { setLPDetails } from '../../slices/createLPSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Toast } from 'primereact/toast';
import { TabView, TabPanel } from 'primereact/tabview';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { MultiSelect } from "primereact/multiselect";
import NetLinePOC from '../../components/predefinedtemplates/lps/netLineTemplate';


import IdTemplate from '../../components/predefinedtemplates/lps/IdTemplate';
import DefaultEmailTemplate from '../../components/predefinedtemplates/email/DefaultEmailTemplate';
import WebinarEmailTemplate from '../../components/predefinedtemplates/email/WebinarEmailTemplate';
import { unSet } from "../../slices/createLPSlice";
import { LandingPageServe } from '../../services/api/LandingPageServ';
import { setEdit } from "../../slices/authSlice";
import TrendLineTemplate from '../../components/predefinedtemplates/lps/trendLineTemplate.js';
import BeckersTemplate from '../../components/predefinedtemplates/lps/beckersDemad7.js';
import './ViewLp.css';
import CodeViewer from '../../components/CodeViewer';
import { Dialog } from 'primereact/dialog';
import BeckersEmailTemplate from '../../components/predefinedtemplates/email/Demand7EmailTemplate.js';

const ViewLp = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  let { id } = useParams();
  const toast = useRef(null);
  const lpDetails = useSelector((state) => state.createLp.data);
  const { isLogged, user } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [lplayout , setLpLayout] = useState(lpDetails.lplayout);
  const [showCodeViewer, setCodeViewer] = useState(false);
  const [codeTemplate, setCodeTemplate] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [selectedDomains, setSelectedDomains] = useState(lpDetails.domains);


  let domains = [
    "lp-gen.knowledgeboats.com",
    "lp-gen.knowledgeboats.info",
    "lp-gen.hitech-articles.com",
    "lp-gen.biz-articles.com",
    "lp-gen.sourcelightmedia.co",
    "lp-gen.intentboats.com",

  ];

  if(process.env.REACT_APP_ENV !=='prod'){
    domains = [
      "localhost",
      "lp-gen-dev.knowledgeboats.com",
      "lp-gen-dev.knowledgeboats.info",
      "lp-gen-dev.hitech-articles.com",
      "lp-gen-dev.biz-articles.com",
      "lp-gen-dev.sourcelightmedia.co"
    ];
  }




  async function getLP() {
    try {
      let data = await LandingPageServe.single(id);
      dispatch(setLPDetails(data));
      reset(data)
    } catch (error) {
      console.log(error)
    } finally {

    }
  }

 const updateStatus = async (status) => {
  try {
    let isEmailForEdit;
    setLoading(true);

    let payload = {};

    if (status) {
      payload.status = status;
    }

    if (lpDetails['changesRequested'] === true) {
      isEmailForEdit = true;
      payload['changesRequested'] = false;
      payload['pocApprovalStatus'] = 'pending';
    } else {
      isEmailForEdit = false;
    }

    if (status === 'published') {
      payload.domains = selectedDomains;
    }

    await LandingPageServe.update(id, payload);

    console.log('Update Payload:', payload);

    // Trigger CALS API when published
    if (status === 'published') {
      await LandingPageServe.pocPublishedMail({
        campaignId: Array.isArray(lpDetails.campaignId)
          ? lpDetails.campaignId
          : lpDetails.campaignId
              .split(',')
              .map(id => id.trim())
              .filter(Boolean),

        pocName: lpDetails.name,
        publishedBy: user.name,
        pocId: lpDetails._id,
        isEmailContentForEdit: isEmailForEdit
      });
    }

    setLoading(false);
    navigate('../lplist');
    dispatch(unSet());

  } catch (error) {
    console.log(error);
    setLoading(false);

    toast.current.show({
      severity: 'error',
      summary: 'Error',
      detail: error.message
    });
  }
};


  useEffect(() => {
    if (!lpDetails._id) {
      getLP()
      localStorage.setItem('template_name' , lpDetails.templateName)
      setLpLayout(lpDetails.lplayout);
    }
    dispatch(setEdit(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lpDetails]);


const cleanEditorHtml = (html) => {
    if (!html) return "";
    let cleaned = html;
    cleaned = cleaned.replace(/<p><br><\/p>/gi, '');
    cleaned = cleaned.replace(/<div><br><\/div>/gi, '');
    // FIXED: exclude td, th and void elements from empty tag removal
    cleaned = cleaned.replace(/<(?!td|th|hr|br|img|input|meta|link)(\w+)(\s[^>]*)?>(\s|&nbsp;)*<\/\1>/gi, '');
    return cleaned.trim();
};

const getHtml = async () => {
    try {
        let data = await LandingPageServe.emailtemplate(id);
        console.log(data);

        // ADDED: clean the html before setting it
        const cleanedData = cleanEditorHtml(data);

        setCodeViewer(true);
        setCodeTemplate(cleanedData);
    } catch (error) {
        console.log(error);
    }
};

  const handleClose = () => {
    dispatch(unSet())
    navigate('../lplist')
  }

  const handleEdit = () => {
    localStorage.setItem('template_name' , lpDetails.templateName)
    navigate(`../edit-lp/${id}`)
  }


  const handleStatus = async (status) => {
    let msg = '';
    if (status === 'archived') { msg = "Are you sure to DELETE this landing page?" }
    if (status === 'published') { 
      
    }
    confirmDialog({
      message: msg,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      defaultFocus: 'accept',
      accept: () => accept(status),
      reject
    });
  }


  const handlePreview = () => {
    navigate(`../preview/${lpDetails._id}/${lpDetails.name}`)
  }


  const accept = async (status) => {
    await updateStatus(status);
  }
  const reject = () => {

  }


  const {
    control,
    formState: { errors },
    reset
  } = useForm({ defaultValues: lpDetails });





  const LPDetailsForm = () => {

    return (
      <>
        <div className="grid pt-5">
          <div className="col-6 col-offset-3">
            <Fieldset legend="LP Summary">
              <form>
                <div className="field">
                  <Controller
                    name="name"
                    control={control}
                    rules={{ required: 'Asset Name  is required.' }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                        <span className="p-float-label">
                          <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} disabled />
                          <label htmlFor={field.name}>Asset Name </label>
                        </span>
                      </>
                    )}
                  />
                </div>
                <div className="field">
                  <Controller
                    name="description"
                    control={control}
                    rules={{ required: 'Description  is required.' }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                        <span className="p-float-label">
                          <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} disabled />
                          <label htmlFor={field.name}>Description </label>
                        </span>
                      </>
                    )}
                  />
                </div>
                <div className="field">
                  <Controller
                    name="assetLink"
                    control={control}
                    rules={{ required: 'Asset  link required.' }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                        <span className="p-float-label">
                          <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} disabled />
                          <label htmlFor={field.name}>Asset Link </label>
                        </span>
                      </>
                    )}
                  />
                </div>
                <div className="field">
                  <Controller
                    name="campaignId"
                    control={control}
                    rules={{ required: 'Campaign ID  is required.' }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                        <span className="p-float-label">
                          <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} disabled />
                          <label htmlFor={field.name}>Campaign ID </label>
                        </span>
                      </>
                    )}
                  />
                </div>
                <div className="field">
                  <Controller
                    name="campaignName"
                    control={control}
                    rules={{ required: 'Campaign Name  is required.' }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                        <span className="p-float-label">
                          <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} disabled />
                          <label htmlFor={field.name}>Campaign Name </label>
                        </span>
                      </>
                    )}
                  />
                </div>
                <div className="field">
                  <Controller
                    name="client"
                    control={control}
                    rules={{ required: 'Client  is required.' }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                        <span className="p-float-label">
                          <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} disabled />
                          <label htmlFor={field.name}>Client </label>
                        </span>
                      </>
                    )}
                  />
                </div>
                <div className="field ">
                  <Controller
                    name="thumbnail"
                    control={control}
                    rules={{ required: 'Thumbnail  is required.' }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                        <span className="p-float-label ">
                          <InputText id={field.name} value={field.value} style={{ borderRadius: "5px" }} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} disabled />
                          <label htmlFor={field.name}>Thumbnail</label>
                        </span>
                      </>
                    )}
                  />
                </div>

                {/* 
                <div className="flex justify-content-end">
                  <Button label=" Next " type="submit" outlined />
                </div> */}
              </form>
            </Fieldset>
          </div>
        </div>
      </>
    )
  }


  const EditEmailTemplate = () => {

    return (
      <>
        {
            (lplayout.isWebinar && localStorage.getItem('template_name') !== "Demand7-Becker's Campaign") && <WebinarEmailTemplate></WebinarEmailTemplate>
        }

        {
            (!lplayout.isWebinar && localStorage.getItem('template_name') !== "Demand7-Becker's Campaign") && <DefaultEmailTemplate></DefaultEmailTemplate>
        }

           {
           (localStorage.getItem('template_name') === "Demand7-Becker's Campaign") && <BeckersEmailTemplate></BeckersEmailTemplate>
        }
      </>
    )
  }

  const EditTemplate = () => {

    return (
      <>
      {  (lpDetails.templateName === 'ID Template' || lpDetails.templateNo === 0) ? (
        <IdTemplate></IdTemplate>
    ) :  (lpDetails.templateName === 'NetLine Template' || lpDetails.templateNo === 1 || lpDetails.templateName === 'NL Template') ? (
      <NetLinePOC></NetLinePOC>
    ) :  (lpDetails.templateName === 'Trendline ID Template' || lpDetails.templateNo === 2 || lpDetails.templateName === 'Trendline Template') ? (
      <TrendLineTemplate></TrendLineTemplate>
    ) : (lpDetails.templateName === "Demand7-Becker's Campaign" || lpDetails.templateNo === 2 || lpDetails.templateName === "Demand7-Becker's Campaign") ? (
      <BeckersTemplate></BeckersTemplate>
    ) : (
      <IdTemplate></IdTemplate>
    )}
      </>
    )
  }


  const modalFooterContent = (
    <div>
      <Button label="No" icon="pi pi-times" onClick={() => setShowConfirmationDialog(false)} className="p-button-text" />
      <Button label="Yes" icon="pi pi-check" loading={loading}  onClick={() => updateStatus('published')} autoFocus />
    </div>
  );





  return (
    <>
      <Toast ref={toast} />
      <div className="card">
        <div className='flex justify-content-between '>
          <div className='flex justify-content-end gap-3'>
            <p className='title'>{lpDetails.name}</p>
          </div>
          <div className='flex justify-content-end gap-3 px-2'>
            <Button onClick={() => handleStatus('archived')} className="w-2rem h-2rem p-0" severity="danger" rounded outline="true" tooltip='Archive' tooltipOptions={{ position: 'left' }} icon="pi pi-trash" />
            <Button onClick={() => setShowConfirmationDialog(true)} className="w-2rem h-2rem p-0" severity="primary" rounded outline="true" tooltip='Publish' tooltipOptions={{ position: 'left' }} icon="pi pi-cloud-upload" />
            <Button onClick={() => handlePreview()} className="w-2rem h-2rem p-0" severity="info" rounded outline="true" tooltip='View as Client' tooltipOptions={{ position: 'left' }} icon="pi pi-eye" />
            <Button onClick={() => getHtml()} className="w-2rem h-2rem p-0" severity="info" rounded outline="true" tooltip='View email html code' tooltipOptions={{ position: 'left' }} icon="pi pi-code" />
            <Button onClick={() => handleEdit()} className="w-2rem h-2rem p-0" severity="info" rounded outline="true" tooltip='Edit landing page' tooltipOptions={{ position: 'left' }} icon="pi pi-pencil" />
            <Button onClick={() => handleClose()} className="w-2rem h-2rem p-0" severity="warning" rounded outline="true" tooltip='Back to listpage' tooltipOptions={{ position: 'left' }} icon="pi pi-times" />
          </div>
        </div>
        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
          <TabPanel header="LP Summary">
            <LPDetailsForm />
          </TabPanel>
          {/* <TabPanel header="Predefined Template">
            <ChooseTemplate />
          </TabPanel> */}
          <TabPanel header="Email Page">
            <EditEmailTemplate />
          </TabPanel>
          <TabPanel header="Landing Page">
            <EditTemplate />
          </TabPanel>
        </TabView>
      </div>
      <ConfirmDialog />

      <Dialog header="Are you sure to PUBLISH this landing page?" visible={showConfirmationDialog} style={{ width: '50vw'}} onHide={() => setShowConfirmationDialog(false)} footer={modalFooterContent}>
        Select Publishing Domains: <MultiSelect value={selectedDomains} onChange={(e) => setSelectedDomains(e.value)} options={domains} 
          placeholder="Select Domains" maxSelectedLabels={3} className="w-30rem" />
      </Dialog>
      <Dialog header="Template  Code" visible={showCodeViewer} style={{ width: '80vw' }} onHide={() => setCodeViewer(false)}>
        <CodeViewer data={codeTemplate}></CodeViewer>
      </Dialog>
    </>

  )
}


export default ViewLp